import { getColourPalette } from 'apiCalls/apiCalls';
import { Modal } from 'components/Modal';
import { EditColourPaletteComponent } from './EditColourPaletteComponent';

export const EditColourPaletteModal = ({ isOpen, setIsOpen, colourPalette, setColourPalette }) => {
    const handleClose = async () => {
        const updatedColourPalette = await getColourPalette(colourPalette.result.id);
        setColourPalette({ loading: false, result: updatedColourPalette });
        setIsOpen(false);
    };

    return (
        <Modal open={isOpen} onClose={handleClose} title="Edit Colour Palette">
            <EditColourPaletteComponent
                colourPalette={colourPalette.result}
                setIsOpen={setIsOpen}
                setColourPalette={setColourPalette}
                colourPaletteId={colourPalette.result.id}
            />
        </Modal>
    );
};
